import { useEffect, useState } from 'react';
import { OWNER_TRANSIENT_FAILURE_MS } from '../lib/owner-transient-failure';

/**
 * 796fa1a4 — na tela do dono, falha de leitura só aparece depois de durar o limite (1 min): `sinceMs` é o início das
 * falhas seguidas (null = lendo bem). Re-renderiza sozinho quando o limite vence, sem esperar a próxima tentativa.
 */
export function useFailureOutlasted(sinceMs: number | null, thresholdMs = OWNER_TRANSIENT_FAILURE_MS): boolean {
  const [, tick] = useState(0);
  const remaining = sinceMs === null ? null : sinceMs + thresholdMs - Date.now();
  useEffect(() => {
    if (remaining === null || remaining <= 0) return;
    const timer = setTimeout(() => tick(n => n + 1), remaining);
    return () => clearTimeout(timer);
  }, [sinceMs, remaining !== null && remaining <= 0]);
  return remaining !== null && remaining <= 0;
}
